//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalProgramFundsWidget = ({ count }: { count: string | number }) => {
  return <StatCard title='Total Program Funds' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalProgramFundsWidget;
